import { gql } from 'apollo-boost';

export const updateEmailTemplate = gql`
mutation updateEmailTemplate(
    $id: Int!,
    $name: String,
    $body: String,
    $subject: String
) {
  updateEmailTemplate(
    id: $id,
    name: $name,
    body: $body,
    subject: $subject
) {
    success
  }
}
`;
